import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationHistoryCard = ({ operation }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'var(--color-success)';
      case 'failed':
        return 'var(--color-error)';
      case 'partial':
        return 'var(--color-warning)';
      case 'running':
        return 'var(--color-primary)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle2';
      case 'failed':
        return 'XCircle';
      case 'partial':
        return 'AlertTriangle';
      case 'running':
        return 'Loader2';
      default:
        return 'Clock';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed':
        return 'Abgeschlossen';
      case 'failed':
        return 'Fehlgeschlagen';
      case 'partial':
        return 'Teilweise';
      case 'running':
        return 'Läuft';
      default:
        return 'Ausstehend';
    }
  };

  return (
    <div className="p-4 rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h4 className="font-semibold text-sm text-[var(--color-foreground)] mb-1">
            {operation?.name}
          </h4>
          <p className="text-xs text-[var(--color-muted-foreground)]">
            {operation?.timestamp}
          </p>
        </div>
        <div
          className="flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium"
          style={{
            backgroundColor: `${getStatusColor(operation?.status)}15`,
            color: getStatusColor(operation?.status)
          }}
        >
          <Icon name={getStatusIcon(operation?.status)} size={12} />
          <span>{getStatusLabel(operation?.status)}</span>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-3">
        <div>
          <div className="text-xs text-[var(--color-muted-foreground)] mb-1">
            Verarbeitet
          </div>
          <div className="text-sm font-semibold text-[var(--color-foreground)]">
            {operation?.processed}
          </div>
        </div>
        <div>
          <div className="text-xs text-[var(--color-muted-foreground)] mb-1">
            Erfolgreich
          </div>
          <div className="text-sm font-semibold text-[var(--color-success)]">
            {operation?.successful}
          </div>
        </div>
        <div>
          <div className="text-xs text-[var(--color-muted-foreground)] mb-1">
            Fehler
          </div>
          <div className="text-sm font-semibold text-[var(--color-error)]">
            {operation?.failed}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between text-xs">
        <span className="text-[var(--color-muted-foreground)]">
          Ausgeführt von: {operation?.executedBy}
        </span>
        {operation?.canRollback && (
          <button className="text-[var(--color-primary)] hover:underline font-medium">
            Rückgängig machen
          </button>
        )}
      </div>
    </div>
  );
};

export default OperationHistoryCard;